import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

const useSpecificTimeSheet = ({ timesheetId, isExternal = false }) => {
  const { accountId } = useAccount();

  const storeKey = ['specific-timesheet', isExternal, timesheetId];

  const { isLoading, data, refetch } = useQuery(
    storeKey,
    () => {
      const params = { accountId, timesheetId };
      return isExternal ? api.fetchSpecificOSTimeSheet(params) : api.fetchSpecificTimeSheet(params);
    },
    {
      staleTime: 0
    }
  );

  return {
    isLoading,
    data: data?.timesheet || {},
    refetch
  };
};

export default useSpecificTimeSheet;
